// removed by extract-text-webpack-plugin
module.exports = {"modal":"p9dCwFg6dTLZ6eiMpY9nA","content":"_2qpzuPtYM4Mew_cM4dMdUI","iconWrapper":"_2sBd-DQyemd9XASqzNwT18","userIcon":"_21e5fghyPHzlQLvCiVoIAw","title":"_1RzVXzZm298ngv7xkqbVAA","boldMessage":"_3KXQPoC38SjpJtGJi1Ttfa","note":"_1gU9VSMFJrLei2FKrLuBfL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/UpdatePropertyActivityModal.scss
// module id = 1791
// module chunks = 0